import { render, staticRenderFns } from "./AccountSidebarAddPayment.vue?vue&type=template&id=80ffa3f2&"
import script from "./AccountSidebarAddPayment.vue?vue&type=script&lang=js&"
export * from "./AccountSidebarAddPayment.vue?vue&type=script&lang=js&"
import style0 from "./AccountSidebarAddPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports